import React, { useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Skeleton } from "antd";

import SingleDeviceHeader from "../SingleDeviceHeader";
import ViewDeviceMapHeader from "./common/header";
import ViewDeviceMapFilter from "./common/filter";
import { useDispatch, useSelector } from "react-redux";

import { fetchDeviceRequest } from "../../../store/actions/singleDeviceHeader";
import { fetchDeviceMapRequest } from "../../../store/actions/deviceMap";
import DeviceMap from "./DeviceMap";
import {dateFormatWithAt} from "../../../global/utility/dateFormat";

import "./device-map.css";
function ViewDeviceMap() {
  const { id } = useParams();
  const location=useLocation();
  
  const mapRef = useRef(null);
  const popupRef = useRef(null);
  const intervalRef = useRef(null);

  const dispatch = useDispatch();
  const isDeviceDataLoading = useSelector(
    (state) => state.singleDeviceHeader.isLoading
  );

  const { user, isBLE, currentIndex, mapData } = useSelector((state) => ({
    isBLE: state.singleDeviceHeader.isBLE,
    currentIndex: state.deviceMap.currentIndex,
    mapData: Array.isArray(state.deviceMap.data) && (state.deviceMap.data || []),
    user: state.user.auth
  }));

  useEffect(() => {
    dispatch(
      fetchDeviceRequest({
        id,
      }),
      dispatch(
        fetchDeviceMapRequest({
          id,
          initial: true
        })
      )
    );
  }, [dispatch, id, isBLE, user?.accountId]);

  return (
    <div className="view-device-dashboard-wrapper">
      {isDeviceDataLoading && <Skeleton paragraph={{ rows: 2 }} />}
      {!isDeviceDataLoading && (
        <SingleDeviceHeader isBLE={isBLE} isMap={true} location={location} id={id} />
      )}
      <div className="view-device-dashboard-full">
        <ViewDeviceMapHeader id={id} />
        <ViewDeviceMapFilter id={id} mapRef={mapRef} intervalRef={intervalRef} popupRef={popupRef}/>
        <div className="d-flex flex-sm-column flex-md-row justify-content-start align-items-start pt-3 pb-2">
          <div className="d-flex flex-column justify-content-start align-items-start">
            <div className="font-face-vzw">Time</div>
            <div>{Array.isArray(mapData) && mapData.length > 0 ? mapData[currentIndex-1]?.properties?.lastupdated : ""}</div>
          </div>
          {/*<div className="d-flex flex-column justify-content-start align-items-start px-4">
            <div className="font-face-vzw">Position</div>
            <div>{mapData.length > 0 && (mapData[0]?.geometry?.coordinates.toString() || "")}</div>
          </div>
           <div className="d-flex flex-column justify-content-start align-items-start">
            <div className="font-face-vzw">Organization</div>
            <div>
              <Link to={"/organization"} state={{search:[deviceData[0]?.organizationName]}} className="link-alarms">
                {deviceData[0]?.organizationName}
              </Link>
            </div>
          </div>
          <div className="d-flex flex-column justify-content-start align-items-start">
            <div className="font-face-vzw">Location</div>
            <div>
              <Link to={"/locationdetails"} state={{search: [deviceData[0]?.locationName]}} className="link-alarms">
                {deviceData[0]?.locationName}
              </Link>
            </div>
          </div> */}
        </div>
        <DeviceMap mapRef={mapRef} intervalRef={intervalRef} popupRef={popupRef}/>
      </div>
    </div>
  );
}

export default ViewDeviceMap;
